<template lang="pug">
.feedback-data-container(@click="expand = !expand")
  .feedback-data
    .feedback-id
      span.material-symbols-outlined {{ typeIcon }}
      span.tag {{ data.feedback }}

    .feedback-description(v-if="!history") {{ data.description }}

    .feedback-type(v-if="!history")
      span.tag(:class="typeClass") {{ typeLabel }}

    .feedback-status(v-if="!history")
      span.tag(:style="statusStyle") {{ statusLabel }}

    .feedback-author(v-if="!history && data.createdBy")
      shNameUser(:dni="data.createdBy")

  transition(name="slide-fade")
    shForm.list-feedback(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import shNameUser from '@/components/elements/NameUser'
import mForm from '@/mixins/form'

export default {
  name: 'Feedback',

  mixins: [mForm],

  components: { shForm, shNameUser },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  computed: {
    typeLabel () {
      const labels = { bug: 'Bug', enhancement: 'Mejora', suggestion: 'Sugerencia' }
      return labels[this.data.type] || this.data.type
    },

    typeIcon () {
      const icons = { bug: 'bug_report', enhancement: 'build', suggestion: 'lightbulb' }
      return icons[this.data.type] || 'rate_review'
    },

    typeClass () {
      const classes = { bug: 'bg-error', enhancement: 'bg-info', suggestion: 'bg-warning' }
      return classes[this.data.type] || ''
    },

    statusLabel () {
      const labels = { pending: 'Pendiente', in_progress: 'En progreso', resolved: 'Resuelto' }
      return labels[this.data.status] || this.data.status
    },

    statusStyle () {
      const styles = {
        pending: 'background:#ffb74d;color:#fff',
        in_progress: 'background:#64b5f6;color:#fff',
        resolved: 'background:#A5AA72;color:#fff'
      }
      return styles[this.data.status] || 'background:#e9e9e7;color:#616161'
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.feedback-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.feedback-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.feedback-id
  display flex
  align-items center
  gap .5em

.feedback-description
  flex 1
  min-width 12em

.list-feedback
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .feedback-data
    column-gap 0
    row-gap 1em

  .feedback-id
    width 10em
  .feedback-description
    width 28em
  .feedback-type
    width 9em
  .feedback-status
    width 9em
  .feedback-author
    width 10em
</style>



// WEBPACK FOOTER //
// src/components/pages/feedback/Feedback.vue